import React, { useState, useEffect } from 'react'
import { IonInput, IonPicker } from '@ionic/react'
import { validMobileOrMail } from '@dt/fe-utils'
import './index.scss'

interface IUsernameInputValue {
  pass: string;
  passType?: string;
  countryCode: number;
}

export interface IUsernameInputProps {
  value: IUsernameInputValue;
  inputType?: 'email' | 'mobile';
  placeholder?: string;
  onFocus?: () => void;
  onBlur?: (value?: any) => void;
  onClick?: () => void;
  onChange?: (value: IUsernameInputValue, valid: boolean) => void;
  onGetTop?: (top: number) => void;
}

const UsernameInput: React.FC<IUsernameInputProps> = (props) => {
  const { value, inputType, placeholder, onFocus, onBlur, onClick, onChange, onGetTop } = props
  const [showPicker, setShowPicker] = useState(false)
  const [passType, setPassType] = useState(inputType || '')
  const [selectedIndex, setSelectedIndex] = useState(
    window.bo === 'cn' ? 0 : window.bo === 'us' ? 1 : 2
  )

  const getCodes = (selectedIndex) => {
    return [
      {
        name: 'code',
        selectedIndex,
        options: [
          {
            text: '+86',
            value: 86,
          },
          {
            text: '+1',
            value: 1,
          },
          {
            text: '+49',
            value: 49,
          },
          {
            text: '+61',
            value: 61,
          },
          {
            text: '+886',
            value: 886,
          },
        ],
      },
    ]
  }

  const handleCodeChange = (countryCode: number) => {
    const data = {
      ...value,
      countryCode,
    }
    const valid = validMobileOrMail(passType as any, data.pass)
    onChange && onChange(data, valid)
    onBlur && onBlur({
      countryCode,
      [passType]: value.pass,
    })
  }

  const handleValueChange = (pass) => {
    // 根据输入自动判断是邮箱还是手机号
    const realType = inputType || (pass ? (/^\d{1,}$/.test(pass) ? 'mobile' : 'email') : '')
    const valid = validMobileOrMail(realType as any, pass)
    setPassType(realType)
    onChange && onChange({
      ...value,
      pass,
      passType: realType
    }, valid)
  }

  useEffect(() => {
    const countryCodeMap = {
      us: 1,
      cn: 0,
      de: 2,
    }
    const countryCode = value.countryCode || getCodes(countryCodeMap[window.bo])[0].options[countryCodeMap[window.bo]].value
    onChange && onChange({
      ...value,
      countryCode
    }, true)
  }, [])

  return (
    <>
      <div className='username-input-wrapper'>
        {!passType && <span style={{ width: '16px' }}></span>}
        {passType === 'email' && (
          <span className='username-input-icon'>
            <i className='iconfont icon-mail--all'></i>
            <i className='iconfont icon-caret--down' style={{ visibility: 'hidden' }}></i>
          </span>
        )}
        {passType === 'mobile' && (
          <span
            className='username-input-icon'
            data-cypid='usernameCodeInput'
            onClick={(e) => setShowPicker(true)}
          >
            <span className='username-input-icon-text'>+{value.countryCode}</span>
            <i className='iconfont icon-caret--down'></i>
          </span>
        )}
        <IonInput
          id='usernameInput'
          value={value.pass}
          placeholder={placeholder || i18n.t('checkout.inputMobileOrEmailLogin')}
          type={inputType === 'mobile' ? 'tel' : 'email'}
          maxlength={inputType === 'mobile' ? 20 : 40}
          // autocomplete='off'
          autocomplete='on'
          onIonBlur={() => {
            onGetTop && onGetTop(0)
            onBlur && onBlur()
          }}
          onIonFocus={(e: any) => {
            const top = document.documentElement?.clientHeight + (e?.target?.clientHeight || 0) - (e?.target?.getBoundingClientRect()?.top || 0)
            onGetTop && onGetTop(e?.target?.clientHeight || e?.target?.getBoundingClientRect()?.top ? top : 0)
            onFocus && onFocus()
          }}
          data-cypid='usernamePhoneInput'
          onClick={() => {
            onClick && onClick()
          }}
          onIonChange={({ detail: { value } }) => handleValueChange(value)}
        />
      </div>
      <IonPicker
        cssClass='mkt-picker light'
        isOpen={showPicker}
        columns={getCodes(selectedIndex)}
        onDidDismiss={() => {
          setShowPicker(false)
          return
        }}
        buttons={[
          {
            text: i18n.t('mkt.common.cancel'),
            handler: () => setShowPicker(false),
          },
          {
            text: i18n.t('mkt.common.confirm'),
            handler: (e) => {
              setSelectedIndex(
                getCodes(0)[0].options.findIndex(
                  (item) => item.value === e.code.value
                )
              )
              handleCodeChange(e.code.value)
            },
          },
        ]}
      />
    </>
  )
}

export default UsernameInput
